import { Div } from '@pinpoint/design-kit';
import React from 'react';
import PropTypes from 'prop-types';

export default function Legend({ orient }) {
  if (orient === 'h') return LegendHorizontal();
  return LegendVertical();
}

Legend.propTypes = {
  orient: PropTypes.oneOf(['h', 'v']).isRequired,
};

function LegendHorizontal() {
  return (
    <Div gridArea="1 / 1 / 2 / 2">
      <Div textSize="caption" textColor="shade4D" m={{ b: '.5rem' }}>
        Legend:
      </Div>
      <Div d="flex" textSize="tiny">
        <Div d="flex" align="center" justify="flex-start">
          <Div d="inline-block" bg="rioGrande" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
          <Div alignSelf="center">
            User
            <br />
            Inputs
          </Div>
        </Div>
        <Div d="flex" align="center" m={{ x: '3rem' }} justify="flex-start">
          <Div d="inline-block" bg="skyBlue" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
          <Div alignSelf="center">
            Results
            <br />
            Without Pinpoint
          </Div>
        </Div>
        <Div d="flex" align="center" justify="flex-start">
          <Div d="inline-block" bg="tealLight" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
          <Div alignSelf="center">
            Results
            <br />
            With Pinpoint
          </Div>
        </Div>
      </Div>
    </Div>
  );
}

function LegendVertical() {
  return (
    <Div
      gridArea="1 / 1 / 5 / 2"
      gridTplR=".1fr repeat(3, .15fr)"
      d="grid"
      textWeight="500"
      data-debug="legend"
      textSize="tiny"
      textColor="black"
    >
      <Div textSize="caption">Legend:</Div>
      <Div d="flex" align="center">
        <Div d="inline-block" bg="rioGrande" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
        <Div alignSelf="center">User Inputs</Div>
      </Div>
      <Div d="flex" align="center">
        <Div d="inline-block" bg="skyBlue" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
        <Div alignSelf="center">
          Results
          <br />
          Without Pinpoint
        </Div>
      </Div>
      <Div d="flex" align="center">
        <Div d="inline-block" bg="tealLight" rounded="md" h="1rem" w="1rem" m={{ r: '.5rem' }} />
        <Div alignSelf="center">
          Results
          <br /> With Pinpoint
        </Div>
      </Div>
    </Div>
  );
}
